import { Component,Input, OnInit } from '@angular/core';
import {INode} from '@feature/nodes/models/node-type';

@Component({
  selector: 'downloadable-file-list',
  templateUrl: './downloadable-file-list.component.html'
})
export class DownloadableFileListComponent implements OnInit {

  @Input() children : INode[];

  constructor() { }

  ngOnInit(): void { }
}
